import { Component, OnInit } from '@angular/core';
import { _HttpClient } from '@delon/theme';

@Component({
  selector: 'app-sucu05-button0030001',
  templateUrl: './sucu05-button0030001.component.html',
})
export class Sucu05Button0030001Component implements OnInit {

    constructor(
        private http: _HttpClient
    ) { }

    ngOnInit() {
    }
    onClick(){
        
    }
}
